// extracted by mini-css-extract-plugin
module.exports = {"watchlistWell":"watchlistWell_watchlistWell__JjwMe"};